import React from "react";
import { useLocation } from "react-router-dom";

import { ConfirmationBlock, MainContainer, Skeleton } from "components";
import { useLoader } from "hooks";
import { useCancelEmailChangeQuery } from "queries";

const CancelEmailChange = () => {
	const { search } = useLocation();
	const token = new URLSearchParams(search)?.get("token");

	const [hasError, setHasError] = React.useState<boolean>(false);

	const {
		isLoading: isLoadingCancelEmailChange,
	}: {
		isLoading: boolean;
	} = useCancelEmailChangeQuery({
		token,
		setHasError,
	});

	const Loader = useLoader(isLoadingCancelEmailChange);

	return (
		<MainContainer className="container-flex">
			<Loader
				skeleton={<Skeleton width="100%" height="500px" />}
				component={
					hasError ? (
						<ConfirmationBlock
							title="Link is expired or doesn’t exist"
							variant="failure"
							style={{ margin: "auto" }}
						/>
					) : (
						<ConfirmationBlock
							title="Your request to rollback email change was confirmed"
							variant="success"
							style={{ margin: "auto" }}
						/>
					)
				}
			/>
		</MainContainer>
	);
};

export default CancelEmailChange;
